import PropTypes from 'prop-types';

export const RateViewerView = {
  AllRates: 'AllRates',
  Carriers: 'Carriers',
};

export const RateViewerViewPropType = PropTypes.oneOf(Object.values(RateViewerView));
